import { Component } from '@theme/component';

class TimberSceneSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.dataset.ready) return;
    this.track = this.querySelector('.tt-slide-track');
    this.slides = [...this.track.children];
    this.count = this.slides.length;
    this.dots = [...this.querySelectorAll('[data-slide]')];
    this.pauseButton = this.querySelector('.tt-slider-pause');
    this.headerObserver = new ResizeObserver(entries => document.documentElement.style.setProperty('--tt-visible-header-height', entries[0].contentRect.height + 'px'));
    const headerGroup = document.getElementById('header-group') || document.querySelector('header-component');
    if (headerGroup) this.headerObserver.observe(headerGroup);
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.stopped = this.motion.matches || this.dataset.autoplay !== 'true';
    this.index = 1; this.busy = false; this.pending = []; this.hovered = false; this.focused = false;
    for (const [slide, atStart] of [[this.slides.at(-1), true], [this.slides[0], false]]) {
      const clone = slide.cloneNode(true);
      clone.dataset.clone = 'true'; clone.inert = true; clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      atStart ? this.track.prepend(clone) : this.track.append(clone);
    }
    this.all = [...this.track.children];
    this.controller = new AbortController(); const { signal } = this.controller;
    this.track.addEventListener('transitionend', event => { if (event.target === this.track && event.propertyName === 'transform') this.finish(); }, { signal });
    this.addEventListener('mouseenter', () => this.hovered = true, { signal });
    this.addEventListener('mouseleave', () => this.hovered = false, { signal });
    this.addEventListener('focusin', () => this.focused = true, { signal });
    this.addEventListener('focusout', event => this.focused = this.contains(event.relatedTarget), { signal });
    this.addEventListener('keydown', event => { if (event.target instanceof HTMLInputElement) return; if (event.key === 'ArrowRight') { event.preventDefault(); this.next(); } if (event.key === 'ArrowLeft') { event.preventDefault(); this.previous(); } }, { signal });
    this.track.addEventListener('pointerdown', event => { this.pointer = { x: event.clientX, y: event.clientY }; }, { signal });
    this.track.addEventListener('pointerup', event => { if (this.pointer) { const dx = event.clientX - this.pointer.x, dy = event.clientY - this.pointer.y; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { this.dragged = true; this.move(dx < 0 ? 1 : -1); } } this.pointer = null; }, { signal });
    this.track.addEventListener('pointercancel', () => this.pointer = null, { signal });
    this.track.addEventListener('click', event => { if (this.dragged) { event.preventDefault(); this.dragged = false; } }, { signal, capture: true });
    this.motion.addEventListener('change', event => { if (event.matches) { this.stopped = true; this.pauseState(); this.finish(); } }, { signal });
    this.timer = setInterval(() => { if (!this.stopped && !this.focused && !this.busy && !document.hidden) this.next(); }, 7000);
    this.dataset.ready = 'true'; this.position(false); this.pauseState();
  }
  disconnectedCallback() {
    this.headerObserver?.disconnect(); this.controller?.abort(); clearInterval(this.timer); clearTimeout(this.fallback);
    this.querySelectorAll('[data-clone]').forEach(el => el.remove()); delete this.dataset.ready;
    super.disconnectedCallback();
  }
  position(animate) {
    this.track.style.transition = animate && !this.motion.matches ? '' : 'none';
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    this.all.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
    const logical = ((this.index - 1) % this.count + this.count) % this.count;
    this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === logical)));
  }
  move(delta) {
    if (this.busy) { this.pending.push(delta); return; }
    this.busy = true; this.index += delta; this.position(true);
    if (this.motion.matches) this.finish();
    else { clearTimeout(this.fallback); this.fallback = setTimeout(() => this.finish(), 700); }
  }
  finish() {
    if (!this.busy) return; this.busy = false; clearTimeout(this.fallback);
    if (this.index === this.count + 1) { this.index = 1; this.position(false); }
    if (this.index === 0) { this.index = this.count; this.position(false); }
    if (this.pending.length) requestAnimationFrame(() => requestAnimationFrame(() => this.move(this.pending.shift())));
  }
  next() { this.move(1); }
  previous() { this.move(-1); }
  choose(event) {
    const target = Number(event.target.closest('[data-slide]')?.dataset.slide);
    if (this.busy || !target || target === this.index) return;
    this.move(target - this.index);
  }
  toggle() { this.stopped = !this.stopped; this.pauseState(); }
  pauseState() { if (!this.pauseButton) return; this.pauseButton.textContent = this.stopped ? '▷' : 'Ⅱ'; this.pauseButton.setAttribute('aria-label', this.stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel); }
}
if (!customElements.get('tt-scene-slider')) customElements.define('tt-scene-slider', TimberSceneSlider);
